export default "__VITE_ASSET__COoBS94F__"